
















































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import WebhookEventsInjectorMixin from "@/mixins/webhookEventsInjectorMixin";

@Component({
  components: {
    "webhook-event-row-item": () =>
      import("@/components/app/admin/settings/webhooks/webhookEventRowItem.vue")
  }
})
export default class WebhookEventsTableView extends Mixins(
  WebhookEventsInjectorMixin
) {
  // Computed

  public get skeletonSize() {
    if (this.$webhookEventsData.webhookEvents.length)
      return this.$webhookEventsData.webhookEvents.length;

    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return !this.$webhookEventsData.isLoading && !this.$webhookEventsData.total;
  }

  public get showSkeletons() {
    return this.$webhookEventsData.isLoading || !this.$webhookEventsData.total;
  }
}
